import COLOURS from "./colours";
import FONTS from "./fonts";
import SPACING from "../base/spacing";
import ANIMATIONS from "./animations";
import IMAGES from "./images";

export const VolkswagenCommercial = {
  COLOURS,
  FONTS,
  SPACING,
  ANIMATIONS,
  IMAGES,
  title: "VWCV Dealerlink",
  name: "VolkswagenCommercial"
};
